import { type Room, type RpcInvocationData } from 'livekit-client'

import { click, type } from 'modules/ai_voice/lib/actions'
import { enqueue } from 'modules/ai_voice/lib/execution-queue'

const RPC_METHODS = {
  click: (data: RpcInvocationData) => {
    return enqueue(async () => {
      try {
        const payload = JSON.parse(data.payload)
        await click(payload)
        return JSON.stringify({ success: true })
      } catch {
        return JSON.stringify({ success: false })
      }
    })
  },
  type: (data: RpcInvocationData) => {
    return enqueue(async () => {
      try {
        const payload = JSON.parse(data.payload)
        await type(payload)
        return JSON.stringify({ success: true })
      } catch {
        return JSON.stringify({ success: false })
      }
    })
  },
}

export async function performRpc(
  room: Room,
  method: string,
  payload: object,
  responseTimeout = 5000
): Promise<{ success: boolean; [key: string]: unknown }> {
  const [participant] = Array.from(room.remoteParticipants.values())

  if (!participant) {
    throw new Error('No remote participant found')
  }

  if (!room.localParticipant) {
    throw new Error('Local participant not available')
  }

  const response = await room.localParticipant.performRpc({
    destinationIdentity: participant.identity,
    method,
    payload: JSON.stringify(payload),
    responseTimeout,
  })

  return JSON.parse(response)
}

export function registerRpcMethods(room: Room) {
  for (const [method, handler] of Object.entries(RPC_METHODS)) {
    room.registerRpcMethod(method, handler)
  }
}

export function unregisterRpcMethods(room: Room) {
  for (const method of Object.keys(RPC_METHODS)) {
    room.unregisterRpcMethod(method)
  }
}
